import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { UtilService } from './util.service';


@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  timeout: any;

  constructor(private apiser:ApiService, private util:UtilService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.util.setCache('userLogin', true);
    clearTimeout(this.timeout);
    this.timeout = setTimeout(()=>{
      this.util.setCache('userLogin', false);
    }, 3400 * 1000)
    if (localStorage.getItem('access_token')) {
      req = req.clone({
        setHeaders: {
         
          Authorization: `${localStorage.getItem('token_type') || 'bearer'} ${localStorage.getItem('access_token')}`,
          'Access-Control-Allow-Origin': '*'
        }
      });
    }else{
      req = req.clone({
        setHeaders: {
         
          'x-api-key': this.apiser.GlobalConstants.api_key,
          'Access-Control-Allow-Origin': '*'
        }
      });
     
    }
    return next.handle(req);
  }

}
